import clsx from 'clsx';
import { memo } from 'react';

const GameSliderNavButton = ({ game, onClick, symbol, active = false }) => (
  <div
    className="group flex h-[47px] w-7 cursor-pointer items-center justify-center"
    onClick={() => onClick(game)}
  >
    <button
      type="button"
      className={clsx(
        'group z-1000 h-3 w-3 items-center justify-center rounded-full bg-white !font-mono text-[0.84rem] font-bold text-zinc-900 select-none md:h-3 md:w-3',

        active
          ? 'pointer-events-none opacity-100'
          : 'cursor-pointer opacity-40 group-hover:opacity-70',
      )}
    >
      {symbol}
    </button>
  </div>
);

export default memo(GameSliderNavButton);
